import { createSlice } from "@reduxjs/toolkit";
import { PathKey } from "./common";
import { AuxColumnSortType } from "@blk/aladdin-web-components";
export const documentListmoduleName = "DocumentList";
export const initialState = {
    DocumentResources: [],
    IsError: false,
    documentDownloadResponse: {
        contentUrl: "",
        error: ""
    },
    filterSelections: {
        audited: [],
        documentCategory: [],
        endDownloadedDate: "",
        endDueDate: "",
        endMetadataModificationDate: "",
        endPublishedDate: new Date().toISOString(),
        endReceivedDate: "",
        endReferenceDate: "",
        fund: [],
        investor: [],
        manager: [],
        startDownloadedDate: "",
        startDueDate: "",
        startMetadataModificationDate: "",
        startPublishedDate: new Date(new Date().setMonth(new Date().getMonth() - 6)).toISOString(),
        startReceivedDate: "",
        startReferenceDate: "",
        template: []
    },
    isLoading: false,
    pageToken: "",
    pendingDownloads: 0,
    selectedDocumentIds: [],
    sortColumn: `${PathKey.PublishDate.toString()}:${AuxColumnSortType.DESCENDING}`,
    totalDownloads: 0
};
const slice = createSlice({
    initialState,
    name: "DocumentList",
    reducers: {
        decrementPendingDownloads(state) {
            state.pendingDownloads = Math.max(0, state.pendingDownloads - 1);
            if (state.pendingDownloads <= 0) {
                state.isLoading = false;
                state.totalDownloads = 0;
            }
        },
        reset(state) {
            state.selectedDocumentIds = [];
        },
        setDataLoading(state, action) {
            state.isLoading = action.payload;
        },
        setPageToken(state, action) {
            state.pageToken = action.payload;
        },
        setPendingDownloads(state, action) {
            state.pendingDownloads = action.payload;
            state.totalDownloads = action.payload;
        },
        setQueryFilters(state, action) {
            state.filterSelections = action.payload.filter;
            state.pageToken = "";
        },
        setSearchResult(state, action) {
            state.DocumentResources = action.payload;
            state.IsError = false;
            state.isLoading = false;
        },
        setSearchResultError(state) {
            state.DocumentResources = [];
            state.IsError = true;
            state.isLoading = false;
        },
        setSelectedRows(state, action) {
            state.selectedDocumentIds = action.payload.map((document) => document.documentId);
        },
        setSortColumn(state, action) {
            state.sortColumn = action.payload;
            state.pageToken = "";
        }
    }
});
export const documentListReducers = slice.reducer;
export const { setSearchResult, setSearchResultError, setSelectedRows, setQueryFilters, setPageToken, reset, decrementPendingDownloads, setDataLoading, setPendingDownloads, setSortColumn } = slice.actions;
